import { render, staticRenderFns } from "./LinkAdd.vue?vue&type=template&id=4b3b6525&"
import script from "./LinkAdd.vue?vue&type=script&lang=js&"
export * from "./LinkAdd.vue?vue&type=script&lang=js&"
import style0 from "./LinkAdd.vue?vue&type=style&index=0&id=4b3b6525&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports